import React, { useState } from 'react';
import DataTable from 'react-data-table-component';
import {urlApiProd} from '../utiles';

const AgregarFFW = ({ cerrar }) => {
    const [botonDeshabilitado, setBotonDeshabilitado] = useState(false);
    const [nombre, setNombre] = useState('');
    const [contactoNombres, setContactoNombres] = useState([]);
    const [contactoCorreos, setContactoCorreos] = useState([]);
    const [nuevoContacto, setNuevoContacto] = useState({ nombre: '', correo: ''});

    const handleSubmit = (e) => {
        e.preventDefault();
        if(!nombre || !contactoNombres || !contactoCorreos){
            alert('Por favor, complete todos los campos');
            return;
        }

        setBotonDeshabilitado(true);

        const nuevoFFW = {
            nombre,
            nombre_contacto: contactoNombres,
            correo_contacto: contactoCorreos,
        };

        const token = localStorage.getItem('token');

        fetch(`${urlApiProd}/addffw`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(nuevoFFW),
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Error al agregar ffw');
            }
            return response.json();
        })
        .then(data => {
            console.log('FFW agregado:', data);
            alert('FFW agregado exitosamente');
            window.location.reload();
        })
        .catch(error => {
            console.error('Error:', error);
        })
        .finally(() => {
            setBotonDeshabilitado(false);
        });
    }

    const handleAgregarContacto = () => {
        if(nuevoContacto.nombre && nuevoContacto.correo){
            setContactoNombres([...contactoNombres, nuevoContacto.nombre])
            setContactoCorreos([...contactoCorreos, nuevoContacto.correo])
        } else {
            alert('Todos los campos del contacto son requeridos.');
        }
    };

    const handleDeleteContacto = (index) => {
        setContactoNombres(contactoNombres.filter((_, i) => i !== index));
        setContactoCorreos(contactoCorreos.filter((_, i) => i !== index));
    };

    return(
        <div className='modal-overlay'>
            <div className='modal1'>
                <div className='card'>
                    <form onSubmit={handleSubmit}>
                        <div className='card-header'>
                            <h3 className='card-title' style={{ textAlign: 'center' }}>Agregar FFW</h3>
                        </div>
                        <div className='card-body'>
                            <div className='input-group mb-3'>
                                <span className='input-group-text'>Nombre</span>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Ingrese nombre"
                                  value={nombre}
                                  onChange={(e) => setNombre(e.target.value)}
                                  required
                                />
                            </div>
                            <div className='input-group mb-3'>
                                <span className='input-group-text'>Nombre Contacto</span>
                                <input
                                type="text"
                                className="form-control"
                                placeholder="Ingrese nombre contacto"
                                value={nuevoContacto.nombre}
                                onChange={(e) => setNuevoContacto({ ...nuevoContacto, nombre: e.target.value })}
                                />
                                <span className='input-group-text'>Correo</span>
                                <input
                                type="email"
                                className="form-control"
                                placeholder="Ingrese correo"
                                value={nuevoContacto.correo}
                                onChange={(e) => setNuevoContacto({ ...nuevoContacto, correo: e.target.value })}
                                />
                            </div>
                            <button type="button" className="btn btn-outline-primary" onClick={handleAgregarContacto}>
                                Agregar Contacto
                            </button>
                            <DataTable 
                                columns={[
                                    { name: 'Nombre', selector: (_, index) => contactoNombres[index] },
                                    { name: 'Correo', selector: (_, index) => contactoCorreos[index] },
                                    {
                                        name: 'Eliminar',
                                        cell: (_, index) => (
                                            <button
                                                type="button"
                                                className="btn btn-outline-danger"
                                                onClick={() => handleDeleteContacto(index)}
                                            >
                                                X
                                            </button>
                                        ),
                                        ignoreRowClick: true,
                                    },
                                ]}
                                data={contactoNombres.map((_, index) => index)} // Usa los índices como data
                                highlightOnHover
                                dense
                                pagination={true}
                            />
                        </div>
                        <div className='card-footer' style={{ textAlign: 'center' }}>
                            <button type="submit" className="btn btn-outline-success mb-3 mt-3" disabled={botonDeshabilitado}>Agregar</button>
                            <button type="button" className="btn btn-outline-danger mb-3 mt-3" onClick={cerrar}>Cancelar</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default AgregarFFW